import { render, staticRenderFns } from "./QualificationResultAddModal.vue?vue&type=template&id=78685c4c&scoped=true"
import script from "./QualificationResultAddModal.vue?vue&type=script&lang=ts"
export * from "./QualificationResultAddModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78685c4c",
  null
  
)

export default component.exports